import { Cambio_destino } from './../../../models/cambio_destino.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';



@Component({
    selector: "page-cambio_destino",
    templateUrl: "./cambio_destino.component.html", 
    providers: [FormService]
})

export class Cambio_destinoComponent {
    
    public rows = [];
      public actualRow;
      public cambioDestino: Cambio_destino;
      public form;
      
      matcher = new FormService();
      

    constructor( public _formService: FormService){

        this.form = new FormGroup({
            cambio_destino: new FormControl(''),
        })

        if(!JSON.parse(localStorage.getItem("cambio_destino"))){
            localStorage.setItem("cambio_destino", JSON.stringify(this.rows));
        }else{
            
            this.rows = JSON.parse(localStorage.getItem("cambio_destino"));

            this.form.controls['cambio_destino'].setValue(this.rows[0]?this.rows[0].cambio_destino:'')
            
            
        }

        
        

    }


    add_cambio_destino(){


            
        localStorage.setItem("cambio_destino",JSON.stringify([]));
        this.actualRow = localStorage.getItem("cambio_destino");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            cambio_destino: this.form.value.cambio_destino,
        })

        localStorage.setItem("cambio_destino", JSON.stringify(this.rows));
        //this.form.reset();

        //this.cip = JSON.parse(localStorage.getItem("cip"));

    }
    delete_cambio_destino(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("cambio_destino", JSON.stringify(this.rows));
            }
        }
    }
}